import { db } from "@/firebaseConfig";

const qrCollection = db.collection("qr");

const saveQR = async data => {
  qrCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("QR successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateQR = async (id, data) => {
  qrCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("QR successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteQR = async id => {
  qrCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("QR successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getQRById = async id => {
  return qrCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getQRByTable = async qr => {
  return qrCollection
    .where("table", "==", qr)
    .get()
    .then(querySnapshot => {
      return !querySnapshot.empty ? querySnapshot.docs[0].data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getQRsByZone = async zonaId => {
  return qrCollection
    .where("zone_id", "==", zonaId)
    .get()
    .then(querySnapshot => {
      return querySnapshot;
    })
    .catch(error => {
      throw error;
    });
};

export {
  qrCollection,
  saveQR,
  updateQR,
  deleteQR,
  getQRById,
  getQRsByZone,
  getQRByTable
};
